export const environment = {

  URL: 'https://uat-oem.demo.simadvisory.com/spriced/platform',  

  SELF_SERVICE_API_BASE_URL: 'https://uat-oem.demo.simadvisory.com',

  SELF_SERVICE_CHAT_API_URL: 'https://uat-oem.demo.simadvisory.com/spriced/platform/ppt-dashboard/generate',
  KAVERI_DASHBOARD_CONFIG_BASE_URL: 'https://uat-oem.demo.simadvisory.com/spriced/platform',
  KEYCLOAK_URL: 'https://auth.simadvisory.com/auth',
  KEYCLOAK_REALM: 'SPRICED_NRP',
  KEYCLOAK_CLIENT_ID: 'PAT_OFFH_Client',
  bearer_token: true,
  PROJECT_ID: 'oh',
  HELP_URL: "https://google.com",
  CLIENT_LOGO_SRC: "",
  CLIENT_LOGO_ICON: "",
  CLIENT_LOGO_TEXT: "",
  COMPANY_LOGO_SRC: "https://assets.alpha.simadvisory.com/logos/image.png",
  COMPANY_LOGO_TEXT: "IMPACT OEM",
  DEFAULT_COMPANY_LOGO: "assets/default-company-logo.svg",
  DEFAULT_MAKE_INDIA_LOGO: "assets/default-make-in-India-logo.svg",
  SECONDARY_LOGO_SRC: "https://assets.alpha.simadvisory.com/Make-in-india.png",
  SECONDARY_LOGO_ENABLED: "false",
  HEADER_COLOR: '',
  SECONDARY_COLOR: '#3688df',
  SECONDARY_COLOR_2: '#3688df',
  ICON_URL: "https://assets.alpha.simadvisory.com/logos/image.png",
  TAB_NAME: "KAVERI LITE",
  HELP_ENABLED: "true",
  FEEDBACK_URL: "https://docs.google.com/forms/u/0/",
  FEEDBACK_ENABLED: "true",
  NOTIFICATION_ENABLED: "true",
  USER_ENABLED: "true",
  LOGOUT_ENABLED: "true",
  CHAT_ENABLED: "false",
  agentApiUrl: 'http://localhost:8081',
  THEME_NAME: 'default',
  USE_ALT_SIDENAV: false,
  THEME_OPTIONS_ENABLED: true,
  THEME_TOGGLE_ENABLED: true,
  PUBLISHED_VIEWS_RAIL_ENABLED: false,
  ALT_COMPANY_LOGO_SRC: 'https://assets.alpha.simadvisory.com/cummins_white.png',
  ALT_SECONDARY_LOGO_SRC: 'https://assets.alpha.simadvisory.com/logos/sim-logo-white.png',
  PROJECT_MODE_QA: false,
  PROJECT_MODE_UAT: true,
//  LANDING_ROUTE: 'dvm-published/consolidated_customer_screen_1_f3h11a',
  LANDING_ROUTE: '/generate-visualization?view=design',
};
/*  */
